module.exports = __webpack_public_path__ + "static/media/designHub.ccd20c2b.png";